export default {
      id: "diagnosis-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#diagnosis",
      toString: function () {
        return this.url;
      }
    }